'use strict';

var Util = require("./util.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Footer = require("../components/footer.js");
var Gatsby = require("../gatsby.js");
var Navigation = require("../components/navigation.js");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var SubscribeForm = require("../components/subscribeForm.js");

require('normalize.css')
;

require('./index.scss')
;

var component = ReasonReact.statelessComponent("TemplateWrapper");

var title = "ReasonConf 2018";

function subscribeFormIfNeeded(hasSubscribeForm) {
  return Util.componentOrNull(hasSubscribeForm, React.createElement("footer", {
                  className: "subscribe"
                }, React.createElement("div", {
                      className: "container_centered grid grid_6cols"
                    }, React.createElement("h2", undefined, Util.s("Subscribe to Newsletter")), ReasonReact.element(/* None */0, /* None */0, SubscribeForm.make(/* array */[])))));
}

function make($$location, children) {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              var match = $$location.pathname;
              var pageType;
              switch (match) {
                case "/" : 
                    pageType = /* Home */0;
                    break;
                case "/badges" : 
                case "/badges/" : 
                    pageType = /* Print */3;
                    break;
                case "/speaker" : 
                case "/speaker/" : 
                    pageType = /* NoLayout */2;
                    break;
                default:
                  pageType = /* Normal */1;
              }
              var isThanksPage = $$location.pathname === "/thanks/";
              switch (pageType) {
                case 0 : 
                    return React.createElement("div", {
                                className: "page"
                              }, React.createElement("main", undefined, Curry._1(children, /* () */0)), subscribeFormIfNeeded(!isThanksPage), ReasonReact.element(/* None */0, /* None */0, Footer.make(/* array */[])));
                case 1 : 
                    return React.createElement("div", {
                                className: "page"
                              }, ReasonReact.element(/* None */0, /* None */0, Gatsby.Helmet[/* make */0](/* Some */[title], /* None */0, /* None */0, /* array */[])), React.createElement("div", {
                                    className: "container container_centered"
                                  }, React.createElement("header", undefined, ReasonReact.element(/* None */0, /* None */0, Navigation.make($$location.pathname, /* None */0, /* array */[]))), React.createElement("article", undefined, Curry._1(children, /* () */0))), subscribeFormIfNeeded(!isThanksPage), ReasonReact.element(/* None */0, /* None */0, Footer.make(/* array */[])));
                case 2 : 
                    return React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, Gatsby.Helmet[/* make */0](/* Some */[title], /* None */0, /* None */0, /* array */[])), Curry._1(children, /* () */0));
                case 3 : 
                    return React.createElement("div", {
                                className: "page-print"
                              }, ReasonReact.element(/* None */0, /* None */0, Gatsby.Helmet[/* make */0](/* Some */[title], /* Some */[{
                                          class: "A4"
                                        }], /* None */0, /* array */[React.createElement("link", {
                                              href: "https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.3.0/paper.css",
                                              rel: "stylesheet",
                                              type: "text/css"
                                            })])), Curry._1(children, /* () */0));
                
              }
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

var $$default = ReasonReact.wrapReasonForJs(component, (function (jsProps) {
        return make(jsProps.location, jsProps.children);
      }));

var Helmet = 0;

exports.Helmet = Helmet;
exports.component = component;
exports.title = title;
exports.subscribeFormIfNeeded = subscribeFormIfNeeded;
exports.make = make;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
/*  Not a pure module */



// WEBPACK FOOTER //
// ./src/layouts/layoutIndex.js